import { apiRequest } from "./axiosInstance";



export const createLocationApi = async (body) => {
  try {
    // let data= await axios.post(`${baseUrl}/user/createUser`,userdata)

    const data = await apiRequest({
      url: `/location/`,
      method: "POST",
      data: body,
    });
    return {sucess:true,message:data?.data};
  } catch (error) {
    console.log(error, "error");
    return {message:error?.response?.data?.message,sucess:false};
  }
};


export const getLocationApi = async (body) => {
  try {
    // let data= await axios.post(`${baseUrl}/user/createUser`,userdata)

    const data = await apiRequest({
      url: `/location/`,
      method: "GET",
    //   data: body,
    });
    return {sucess:true,data:data?.data};
  } catch (error) {
    console.log(error, "error");
    return {message:error?.response?.data?.message,sucess:false};
  }
};

export const updateLocationApi = async (id,body) => {
  try {
    // let data= await axios.post(`${baseUrl}/user/createUser`,userdata)

    const data = await apiRequest({
      url: `/location/${id}`,
      method: "PUT",
      data: body,
    });
    return {sucess:true,message:data?.data};
  } catch (error) {
    console.log(error, "error");
    return {message:error?.response?.data?.message,sucess:false};
  }
};


export const deleteLocationApi = async (id) => {
  try {
    // let data= await axios.post(`${baseUrl}/user/createUser`,userdata)

    const data = await apiRequest({
      url: `/location/${id}`,
      method: "DELETE",
    //   data: body,
    });
    return {sucess:true,message:data?.data};
  } catch (error) {
    console.log(error, "error");
    return {message:error?.response?.data?.message,sucess:false};
  }
};